// extracted by mini-css-extract-plugin
export var sliderRange = "_pr-2";
export var sliderRoot = "_pr-0";
export var sliderThumb = "_pr-3";
export var sliderTrack = "_pr-1";